import React, { useState } from "react";
import { EditIcon } from "@icons";
import { Button } from "@design-system/Button/Button";
import { Input } from "@design-system/Input/Input";
// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { ToggleableInput } from "@design-system/ToggleableInput/ToggleableInput";
import { TextControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./SpecializedInputPlayground.module.scss";

export const ToggleableInputPlayground = () => {
    const [value, setValue] = useState("Quarterly bookkeeping review");

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Value</h2>
                        <TextControl
                            label="Local value"
                            value={value}
                            onChange={setValue}
                        />
                    </section>
                    <section>
                        <h2>Try it</h2>
                        <p className={styles.hint}>
                            Click the read-only row or focus it and press Enter
                            to switch into edit mode. Save or blur the input to
                            return to read mode.
                        </p>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary="Read ↔ edit"
                output={JSON.stringify(
                    {
                        props: {
                            renderDefaultState: "provided",
                            renderInputState: "provided",
                        },
                        consumerState: {
                            value,
                        },
                    },
                    null,
                    2,
                )}
            >
                <ToggleableInput
                    renderDefaultState={(toggleInput) => (
                        <div
                            className={styles.toggleableDisplay}
                            {...toggleInput}
                        >
                            <span>{value || "Add a value"}</span>
                            <EditIcon />
                        </div>
                    )}
                    renderInputState={(toggleInput, inputRef) => (
                        <div className={styles.toggleableEditor}>
                            <Input
                                ref={inputRef}
                                size="xl"
                                className={styles.toggleableInput}
                                value={value}
                                onChange={(event) =>
                                    setValue(event.target.value)
                                }
                                onBlur={toggleInput.onClick}
                            />
                            <Button
                                type="button"
                                variant="primary"
                                size="md"
                                onMouseDown={(event) => event.preventDefault()}
                                onClick={toggleInput.onClick}
                            >
                                Save
                            </Button>
                        </div>
                    )}
                />
            </ShowcasePreview>
        </SandboxLayout>
    );
};
